/** @param {number | bigint} val */
export const currencyFormatter = val => {
  return new Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
    style: 'currency'
  }).format(val);
};

export default currencyFormatter;
